@if (auth.isLoading$ | async) {
  <div class="flex max-h-full">
    <app-loading></app-loading>
  </div>
} @else {
  @if (profile) {
    <app-profile-content [user]="profile"></app-profile-content>
  }
}

